// assets/cart-bundle.js — v4.0.4-simple
// Single-tier charms selector, robust checkout toggle, aggressively reacts to cart changes
(() => {
  if (!window.cartBundleSettings || !window.cartBundleSettings.enabled) return;

  const S = window.cartBundleSettings;
  const T = window.cartBundleI18n || {};
  const modal = document.getElementById('cb-modal');

  const btnAdd   = modal ? document.getElementById('cb-add') : null;
  const btnClose = modal ? document.getElementById('cb-close') : null;
  const sizePopup = modal ? document.getElementById('cb-size-popup') : null;
  const sizePopupTitle = modal ? document.getElementById('cb-size-popup-title') : null;
  const sizePopupList = modal ? document.getElementById('cb-size-popup-list') : null;
  const sizePopupProduct = modal ? document.getElementById('cb-size-popup-product') : null;
  const sizePopupClose = modal ? document.getElementById('cb-size-popup-close') : null;

  const qsa = (s, el = document) => [...el.querySelectorAll(s)];
  const qs  = (s, el = document) => el.querySelector(s);
  const calloutEl = () => document.querySelectorAll('[data-cb-callout]');
  const isMobile  = () => window.matchMedia('(max-width: 640px)').matches;
  const REQUIRED  = Number(S.required_count || 1);

  let selectedCharms = new Set();
  let selectedSizes = new Map(); // Map<variantId, sizeValue>
  let cartToken = null;
  let addingInFlight = false;

  function shouldGoToCheckout() {
    const v = (S.cart_bundle_checkout_on_add + '').trim().toLowerCase();
    return v === 'true' || v === '1';
  }

  async function cartJSON() {
    const r = await fetch('/cart.js?cb=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    return r.json();
  }

  const declineKey = t => 'cb_declined_' + t;
  function saveDecline(){ if (cartToken) sessionStorage.setItem(declineKey(cartToken), '1'); }
  function declined(){ return cartToken && sessionStorage.getItem(declineKey(cartToken)) === '1'; }

  const QUALIFY_HANDLE = String(S.qualifying_collection_handle || '').trim();
  const QUALIFY_BY_COLLECTION = !!S.qualify_by_collection && !!QUALIFY_HANDLE;
  const DEBUG = location.search.includes('cb=debug') || window.CB_DEBUG === true;
  const log = (...a) => { if (DEBUG) console.log('[CB]', ...a); };

  // Collection membership is resolved in Liquid (sections/cart-bundle-qualify.liquid)
  // because collection.products is capped at 50 and products.json can't cover
  // large collections reliably.
  async function fetchQualifyingData(){
    const res = await fetch('/?section_id=cart-bundle-qualify&cb=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('qualify section ' + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const node = doc.querySelector('[data-cb-qualify]');
    if (!node) throw new Error('qualify payload missing');
    const data = JSON.parse(node.textContent);
    if (!data || typeof data.qualifying_total !== 'number') throw new Error('qualify payload invalid');
    return data;
  }

  // Total that counts toward the gift threshold: whole cart, or — when the
  // collection flag is on — only the lines from the qualifying collection.
  // Returns null when membership could not be resolved.
  async function qualifyingTotal(cart){
    if (!QUALIFY_BY_COLLECTION) {
      log('collection gating off — using cart total', cart.total_price);
      return Number(cart.total_price || 0);
    }
    try {
      const data = await fetchQualifyingData();
      log('qualify', QUALIFY_HANDLE, data);
      return Number(data.qualifying_total || 0);
    } catch (e) {
      console.warn('[CB] qualifying collection could not be resolved', e);
      return null;
    }
  }

  // Support ?cb=open for debug / forced open
  if (location.search.includes('cb=open')) {
    document.addEventListener('DOMContentLoaded', () => {
      try { resetUI(); } catch(_) {}
      openModal();
    });
  }

  function openModal(){
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    updateNoteText();
  }

  function closeModal(){
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  if (modal) {
    btnClose?.addEventListener('click', closeModal);
    modal.querySelector('.cb-backdrop')?.addEventListener('click', closeModal);
  }

  document.addEventListener('click', (e) => {
    const el = e.target.closest('.cb-callout[data-cb-open], [data-cb-open]');
    if (el){
      resetUI();
      openModal();
    }
  });

  if (modal) {
    modal.addEventListener('click', (e) => {
      const declineBtn = e.target.closest('[data-cb-decline]');
      if (declineBtn){
        saveDecline();
        closeModal();
      }
    });
  }

  let activeSizeItem = null;

  function updateSizeLabel(btn){
    const sizeSpan = btn.querySelector('.cb-size-current');
    if (!sizeSpan) return;
    const vid = btn.dataset.variantId ? Number(btn.dataset.variantId) : null;
    const size = (vid && selectedSizes.has(vid)) ? selectedSizes.get(vid) : '';
    sizeSpan.textContent = size ? `Selected: ${size}` : '';
  }

  function selectItem(btn){
    const vid = btn.dataset.variantId ? Number(btn.dataset.variantId) : null;
    if (!vid) return;
    selectedCharms.add(vid);
    btn.setAttribute('aria-pressed', 'true');
    updateSizeLabel(btn);
  }

  function deselectItem(btn){
    const vid = btn.dataset.variantId ? Number(btn.dataset.variantId) : null;
    if (!vid) return;
    selectedCharms.delete(vid);
    selectedSizes.delete(vid);
    btn.setAttribute('aria-pressed', 'false');
    updateSizeLabel(btn);
  }

  function openSizePopup(btn){
    if (!sizePopup || !sizePopupList || !sizePopupProduct || !sizePopupTitle) return;
    const options = btn.dataset.sizeOptions ? JSON.parse(btn.dataset.sizeOptions) : [];
    const unavailableSizes = btn.dataset.sizeUnavailable ? JSON.parse(btn.dataset.sizeUnavailable) : [];
    if (!options || !options.length) return;

    activeSizeItem = btn;
    const productTitle = btn.dataset.productTitle || btn.querySelector('.cb-name')?.textContent || '';
    sizePopupTitle.textContent = S.size_label || 'Select Size';
    sizePopupProduct.textContent = productTitle;
    sizePopupList.innerHTML = '';

    const popupImage = document.getElementById('cb-size-popup-image');
    if (popupImage) {
      const imageUrl = btn.dataset.productImage || '';
      popupImage.src = imageUrl;
      popupImage.alt = productTitle ? `${productTitle} image` : 'Product image';
      popupImage.style.display = imageUrl ? 'block' : 'none';
    }

    const currentSize = selectedSizes.get(Number(btn.dataset.variantId));
    options.forEach((value) => {
      const option = document.createElement('button');
      const disabled = unavailableSizes.includes(value);
      option.type = 'button';
      option.className = 'cb-size-swatch';
      option.dataset.sizeValue = value;
      option.textContent = value;
      option.setAttribute('aria-selected', currentSize === value ? 'true' : 'false');
      if (disabled) {
        option.disabled = true;
        option.setAttribute('aria-disabled', 'true');
        option.classList.add('cb-size-swatch--unavailable');
      }
      sizePopupList.append(option);
    });

    sizePopup.setAttribute('aria-hidden', 'false');
  }

  function closeSizePopup(){
    if (!sizePopup) return;
    sizePopup.setAttribute('aria-hidden', 'true');
    activeSizeItem = null;
  }

  async function onPick(e){
    const btn = e.target.closest('.cb-item');
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    const vid  = btn.dataset.variantId ? Number(btn.dataset.variantId) : null;
    if (!vid) return;

    const pressed = btn.getAttribute('aria-pressed') === 'true';
    const sizeRequired = btn.dataset.sizeRequired === 'true';
    const sizeOptions = btn.dataset.sizeOptions ? JSON.parse(btn.dataset.sizeOptions) : [];

    if (!pressed && sizeRequired && sizeOptions.length) {
      return openSizePopup(btn);
    }

    if (pressed) {
      deselectItem(btn);
    } else {
      if (selectedCharms.size >= REQUIRED) return;
      selectItem(btn);
    }

    enforceCharmsLimit();
    validate();
  }

  if (modal) {
    modal.removeEventListener('click', onPick);
    modal.addEventListener('click', (e) => {
      const sizeBtn = e.target.closest('.cb-size-swatch');
      if (sizeBtn && sizePopup && sizePopup.contains(sizeBtn)) {
        e.preventDefault();
        e.stopPropagation();
        onSizeSelect(sizeBtn);
        return;
      }
      // Handle charm item clicks
      onPick(e);
    }, { passive: false });
  }

  if (sizePopupClose) {
    sizePopupClose.addEventListener('click', closeSizePopup);
  }

  function onSizeSelect(btn){
    if (!S.size_selection_enabled || !activeSizeItem) return;

    const vid = activeSizeItem.dataset.variantId ? Number(activeSizeItem.dataset.variantId) : null;
    if (!vid) return;

    const sizeValue = btn.dataset.sizeValue;
    if (!sizeValue) return;

    selectedSizes.set(vid, sizeValue);
    updateSizeLabel(activeSizeItem);

    qsa('.cb-size-swatch', sizePopupList).forEach(s => {
      s.setAttribute('aria-selected', s === btn ? 'true' : 'false');
    });

    if (!selectedCharms.has(vid)) {
      if (selectedCharms.size >= REQUIRED) {
        alert(S.size_error || 'Please select a size for each item.');
        closeSizePopup();
        return;
      }
      selectItem(activeSizeItem);
    }

    closeSizePopup();
    enforceCharmsLimit();
    validate();
  }

  function enforceCharmsLimit(){
    const count = selectedCharms.size;
    const disable = count >= REQUIRED;
    qsa('.cb-item[data-component="charm"]').forEach(b => {
      const id = Number(b.dataset.variantId);
      const isSel = selectedCharms.has(id);
      b.setAttribute('aria-disabled', (!isSel && disable) ? 'true' : 'false');
    });
  }

  function validate(){
    const charmsOk = selectedCharms.size === REQUIRED;

    let sizesOk = true;
    if (S.size_selection_enabled && charmsOk) {
      for (const vid of selectedCharms) {
        const item = qs(`.cb-item[data-variant-id="${vid}"]`);
        const requiresSize = item?.dataset.sizeRequired === 'true';
        if (requiresSize && !selectedSizes.has(vid)) {
        }
      }
    }
    
    const ok = charmsOk && sizesOk;
    if (btnAdd) btnAdd.disabled = !ok;
  }

  function updateNoteText(){
    const note = qs('[data-general-note]');
    if (!note) return;

    const required = REQUIRED;
    const noteOne   = note.getAttribute('data-note-one')   || (T.choose_one   || 'Choose your free charm');
    const noteThree = note.getAttribute('data-note-three') || (T.choose_three || 'Choose your three charms');

    if (required === 1) {
      note.innerHTML = noteOne;
    } else if (required === 3) {
      note.innerHTML = noteThree;
    } else {
      note.innerHTML = `${T.choose_one || 'Choose your free charm(s)'} (${required})`;
    }
  }

  function groupBundles(cart){
    const byId = {};
    cart.items.forEach((l) => {
      const p = l.properties || {};
      const bid  = p._cbid;
      const comp = p._cbcomp;
      if (!bid) return;
      (byId[bid] ||= { keys: [], charms: 0 }).keys.push(l.key);
      if (comp === 'charm') byId[bid].charms += l.quantity || 1;
      // Custom bundle-builder lines (bundle-page-alpine) share the _cbid grouping
      // key but are NOT charm bundles — tag them so ensure() leaves them alone.
      if (comp === 'bundle-base' || comp === 'bundle-item') byId[bid].kind = 'bundle';
    });
    return byId;
  }

  async function getExistingBundle(){
    const cart = await cartJSON();
    const groups = groupBundles(cart);
    const id = Object.keys(groups)[0];
    return id ? { id, keys: groups[id].keys } : null;
  }

  async function removeKeys(keys){
    if (!keys?.length) return;
    const updates = {}; keys.forEach(k => updates[k] = 0);
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ updates })
    });
    await new Promise(r => setTimeout(r, 150));
  }

  async function addOne(it){
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify(it)
    });
    if (!res.ok) {
      const msg = await res.text().catch(()=> '');
      throw new Error(msg || 'Add failed');
    }
    return res.json();
  }

  async function addSequential(items){
    const addedKeys = [];
    try {
      for (const it of items){
        await new Promise(r => setTimeout(r, 60));
        const data = await addOne(it);
        if (data?.key) addedKeys.push(data.key);
      }
      return true;
    } catch (e){
      if (addedKeys.length){
        const updates = {}; addedKeys.forEach(k => updates[k] = 0);
        await fetch('/cart/update.js', {
          method: 'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ updates })
        });
      }
      throw e;
    }
  }

  function lockFooterHeight(lock){
    const footer = modal.querySelector('.cb-footer');
    if (!footer) return;
    footer.style.minHeight = lock ? footer.getBoundingClientRect().height + 'px' : '';
  }

  async function refreshCartDrawer() {
    try {
      const sections = ['cart-drawer', 'cart-icon-bubble'];
      const url = `/cart?sections=${sections.join(',')}&timestamp=${Date.now()}`;

      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;

      const parsedState = await res.json();

      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      drawer.renderContents({
        id: Date.now(),
        sections: parsedState,
      });

      const drawerContent = document.getElementById('CartDrawer');
      const overlay = document.getElementById('CartDrawer-Overlay');

      drawer.classList.add('active');
      drawerContent?.classList.add('active');
      overlay?.classList.add('active');

    } catch (e) {
      console.error('[CB] drawer refresh failed', e);
    }
  }


  btnAdd?.addEventListener('click', async () => {
    if (addingInFlight) return;
    addingInFlight = true;
    btnAdd.disabled = true;
    lockFooterHeight(true);

    try {
      if (selectedCharms.size !== REQUIRED){
        alert('Please select the required number of charms.');
        return;
      }

      // Check if size selection is required and all sizes are selected
      if (S.size_selection_enabled) {
        if (selectedCharms.size !== selectedSizes.size) {
          alert(S.size_error || 'Please select a size for each item.');
          return;
        }
        for (const vid of selectedCharms) {
          if (!selectedSizes.has(vid)) {
            alert(S.size_error || 'Please select a size for each item.');
            return;
          }
        }
      }

      const existing = await getExistingBundle();
      if (existing) await removeKeys(existing.keys);

      const bundleId = 'B' + Date.now().toString(36);
      const items = [];

      selectedCharms.forEach(id => {
        const props = {
          _cbid: bundleId,
          _cbcomp: 'charm'
        };

        const itemEl = qs(`.cb-item[data-variant-id="${id}"]`);
        const variantPrice = itemEl?.dataset.variantPrice;
        if (variantPrice) {
          props._cbrrp = variantPrice;
        }
        
        // Add size to properties if size selection is enabled
        if (S.size_selection_enabled && selectedSizes.has(id)) {
          props._cbsize = selectedSizes.get(id);
        }
        
        items.push({
          id,
          quantity: 1,
          properties: props
        });
      });

      await addSequential(items);

      await cartJSON();
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      closeModal();

      if (shouldGoToCheckout()) {
        window.location.href = '/checkout';
      } else {
        await refreshCartDrawer();
      }

    } catch (e) {
      console.error('[CB] add error', e);
      alert('Sorry, we couldn’t add your gift. Please try again.');
    } finally {
      addingInFlight = false;
      lockFooterHeight(false);
      validate();
    }
  });

  function renderCallout({ unlocked, hasBundle }){
    const roots = calloutEl();
    roots.forEach(root => {
      if (!root) return;

      if (!unlocked){
        root.innerHTML = '';
        root.hidden = true;
        return;
      }

      const unlockedMsg = T.unlocked_t1 || T.shipping_offer || '';
      const appliedMsg  = T.applied_t1  || T.shipping_offer || '';
      const msg = hasBundle ? appliedMsg : unlockedMsg;

      root.hidden = false;
      root.className = 'cb-callout';
      root.removeAttribute('data-cb-open');

      if (!hasBundle){
        root.setAttribute('data-cb-open', '');
        root.setAttribute('role', 'button');
        root.setAttribute('tabindex', '0');
        root.setAttribute('aria-label', (T.choose_now || 'Choose now'));
      } else {
        root.removeAttribute('role');
        root.removeAttribute('tabindex');
        root.removeAttribute('aria-label');
      }

      root.innerHTML = `
        <div class="cb-text"><strong>${T.callout_title || 'Free charm'}</strong> — ${msg || ''}</div>
        <div class="cb-spacer"></div>
        ${!hasBundle ? `<span class="cb-btn-mini">${T.choose_now || 'Choose now'}</span>` : ``}
      `;
    });
  }

  function resetUI(){
    selectedCharms = new Set();
    selectedSizes = new Map();
    qsa('.cb-item[data-component="charm"]').forEach(b => {
      b.setAttribute('aria-pressed', 'false');
      b.removeAttribute('aria-disabled');
      const sizeSpan = b.querySelector('.cb-size-current');
      if (sizeSpan) sizeSpan.textContent = '';
    });
    qsa('.cb-size-swatch').forEach(s => {
      s.setAttribute('aria-selected', 'false');
    });
    if (sizePopup) sizePopup.setAttribute('aria-hidden', 'true');
    activeSizeItem = null;
    updateNoteText();
    enforceCharmsLimit();
    validate();
  }

  async function ensure(){
    try {
      const cart = await cartJSON();
      if (!cart) return;
      if (!cartToken || cartToken !== cart.token) cartToken = cart.token;

      const total = await qualifyingTotal(cart);
      const minCents = (Number(S.min_total || 0)) * 100;
      const maxCents = (Number(S.max_total || 0)) * 100;

      // Membership unknown — hide the offer but leave the cart untouched.
      if (total === null) {
        renderCallout({ unlocked: false, hasBundle: false });
        return;
      }

      const unlocked = total >= minCents && (!maxCents || total <= maxCents);
      log('ensure', { total, minCents, maxCents, unlocked, gated: QUALIFY_BY_COLLECTION });

      const groups = groupBundles(cart);

      // Remove incomplete bundles or bundles when not unlocked
      const required = REQUIRED;
      for (const [bid, g] of Object.entries(groups)){
        // Skip custom bundle-builder groups — they're not charm bundles and the
        // charm gating below would otherwise delete them from the cart.
        if (g.kind === 'bundle') continue;
        const complete = unlocked && (g.charms === required);
        if (!complete) {
          await removeKeys(g.keys);
        }
      }

      const post = Object.keys(groups).length ? await cartJSON() : cart;
      const groups2 = groupBundles(post);
      // Only charm bundles drive the charm callout — ignore custom bundle-builder groups.
      const hasBundle = Object.values(groups2).some(g => g.kind !== 'bundle');

      renderCallout({ unlocked, hasBundle });

      // The modal is opened only when the user clicks the mini-cart/cart callout.
      // Do not auto-open the bundle modal on homepage or any page load.
    } catch (e) {
      console.warn('[CB] ensure error', e);
    }
  }

  // Coalesce ensure() calls so a burst of triggers (e.g. high-frequency
  // third-party DOM mutations seen by the observer, or rapid cart events)
  // can only ever schedule ONE pending ensure() instead of stacking many
  // setTimeouts — each of which issues a cart fetch.
  let _ensureTimer = null;
  function scheduleEnsure(delay) {
    if (_ensureTimer) return;
    _ensureTimer = setTimeout(() => { _ensureTimer = null; ensure(); }, delay || 60);
  }

  // Initial load + section load
  document.addEventListener('DOMContentLoaded', () => {
    updateNoteText();
    ensure();

    const root = document.body;
    try {
      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          if (m.type === 'childList') {
            if ([...m.addedNodes].some(n => {
              return (
                n.nodeType === 1 && (
                  n.querySelector?.('[data-cb-callout]') ||
                  n.querySelector?.('#cb-modal') ||
                  n.matches?.('[data-cb-callout], #cb-modal')
                )
              );
            })) {
              scheduleEnsure(30);
            }
          }
        }
      });

      mo.observe(root, { childList: true, subtree: true });
    } catch (_) {}
  });

  window.addEventListener('pageshow', ensure);
  document.addEventListener('shopify:section:load', ensure);

  // React to cart changes from theme JS (if they exist)
  ['cart:refresh', 'cart:updated', 'theme:cart:change', 'product:added', 'ajaxCart:afterCartLoad', 'cart-update'].forEach((ev) => {
    document.addEventListener(ev, () => {
      scheduleEnsure(80);
    });
  });

  // Fallback: when any "add to cart" style button is clicked, re-check cart shortly after
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(
      '[data-add-to-cart],' +
      'button[name="add"],' +
      'button[type="submit"][name="add"],' +
      'form[action*="/cart/add"] button[type="submit"],' +
      'form[action*="/cart/add"] input[type="submit"]'
    );
    if (!btn) return;
    scheduleEnsure(400);
  });

})();
